/* 🤖 this file was generated by svg-to-ts */
export const kzIconsKaza: {
  name: 'kaza';
  data: string;
} = {
  name: 'kaza',
  data: `<svg viewBox="0 0 32 23"><g stroke="currentColor" stroke-width="1.2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="m27.828 5.704.174 16.4-24.206.255-.174-16.4"/><path d="m13.6 22.256-.105-9.943-4.912.052.105 9.942M17.858 16.768l-.032-3.065 5.14-.055.033 3.066zM.596 6.774 15.678.594l15.192 5.88"/></g></svg>`
};
